import { render, staticRenderFns } from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=template&id=36d9c81a&scoped=true&"
import script from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=script&lang=js&"
export * from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=script&lang=js&"
import style0 from "./cash-collection-by-cashier-and-top10-fast-product-sold.vue?vue&type=style&index=0&id=36d9c81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9c81a",
  null
  
)

export default component.exports